var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7809 0.634761L10.0406 5.96957L7.40297 9.73225L6.48652 11.0361L2.67913 6.59544L2.63443 6.54328C2.20973 6.03663 1.47955 5.88761 0.876027 6.18564C0.749363 6.23035 0.630149 6.29741 0.525837 6.37936C0.220352 6.64014 0.0340806 7.00524 0.00427714 7.40758C-0.0255263 7.80248 0.101138 8.19737 0.361918 8.50286L5.4732 14.471C5.75634 14.8063 6.17358 15 6.61318 15H6.68769C7.14965 14.9776 7.58179 14.7392 7.85002 14.3592L9.29549 12.3028L12.0672 8.34639L16.2546 2.37826C16.7314 1.70023 16.5601 0.761427 15.882 0.284573C15.1966 -0.207183 14.2578 -0.0432666 13.7809 0.634761Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.a2adeafa.svg";
export { ForwardRef as ReactComponent };